module.exports = __webpack_public_path__ + "img/care1.5970db53.png";